<script>
import cloneDeep from 'lodash/cloneDeep'
import lazyLoadComponent from '@router/lazyload-component'
import { bankTypeList } from '@utils/filter-value-to-text'

export default {
  props: {
    currentOrder: {
      type: Object,
      default: () => {},
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PaymentFormDialog: () => lazyLoadComponent(import('./PaymentFormDialog')),
  },
  data() {
    return {
      bankTypeList,
      submitData: {},
      installmentDialogVisible: false,
    }
  },
  computed: {
    submitRules() {
      return {
        bankType: [
          {
            required: true,
            message: '請選擇轉帳銀行',
          },
        ],
      }
    },
    storeCashflowSetting() {
      return this.currentOrder.storeCashflowSetting
    },
    isDepositOrderType() {
      return this.currentOrder.params.some(({ type }) => type === 'deposit-plan')
    },
  },
  watch: {
    currentOrder: {
      handler(val) {
        this.submitData = cloneDeep({
          bankType: '',
          ...val,
        })
      },
      immediate: true,
    },
  },
  methods: {
    async onClickStore() {
      await this.$refs.form.validate()
      if (this.submitData.paymentMethod === 'Installment') {
        this.installmentDialogVisible = true
        return
      }
      this.$emit('update', this.submitData)
    },
    updateInstallmentOrder(data) {
      this.$emit('update', data)
    },
    onChangePaymentMethod() {
      const resetPaymentInfo = () => {
        this.submitData.Card4No = ''
        this.submitData.PayerAccount5Code = ''
        this.submitData.bankType = ''
      }
      resetPaymentInfo()
    },
    onClickClose() {
      this.$emit('close')
    },
  },
}
</script>
<template>
  <div :class="$style.orderformSection">
    <div class="orderformSection__right__header">
      <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="onClickClose"><i class="el-dialog__close el-icon el-icon-close"></i></button>
      <h4 class="orderformSection__right__title">編輯付款方式</h4>
    </div>
    <div class="orderformSection__right__content">
      <div class="payment-radio">
        <div style="display: flex; margin-bottom: 10px">
          <h6>付款方式</h6><el-checkbox v-model="submitData.allowExpired" class="check-by-head text-muted-0" :false-label="0" :true-label="1">可逾期付款</el-checkbox>
        </div>
        <el-radio-group v-model="submitData.paymentMethod" @change="onChangePaymentMethod">
          <el-radio v-if="$hasDeposit() && !isDepositOrderType" label="Deposit" border>儲值點數抵扣</el-radio>
          <el-radio label="Cash" border>到店付款(現金)</el-radio>
          <el-radio label="StoreCredit" border>現場刷卡</el-radio>
          <el-radio label="Atm" border>線下匯款</el-radio>
          <el-radio v-if="storeCashflowSetting === 1" label="Credit" border>信用卡付款</el-radio>
          <el-radio v-if="storeCashflowSetting !== 0" label="Vacc" border>ATM虛擬帳戶</el-radio>
          <el-radio label="Installment" border>分期付款</el-radio>
        </el-radio-group>
        <el-form ref="form" :model="submitData" :rules="submitRules">
          <el-form-item v-if="submitData.paymentMethod === 'Vacc'" prop="bankType" class="el-form-item--white-bg-border" label="轉帳銀行">
            <el-select v-model="submitData.bankType">
              <el-option v-for="bank in bankTypeList" :key="bank.id" :value="bank.id" :label="bank.title"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="btn-group-inline" style="padding: 30px 0 50px">
          <el-button plain class="is-round" @click="onClickClose">取消</el-button>
          <el-button :loading="loading" class="is-round" type="primary" @click="onClickStore">確認變更</el-button>
        </div>
      </div>
    </div>
    <PaymentFormDialog
      :visible.sync="installmentDialogVisible"
      :payment-way="'installments'"
      :installment-order="submitData"
      :price-total="submitData.priceTotal"
      :handle-dialog-status="'reservationAndPrepaid'"
      @update="updateInstallmentOrder"
    ></PaymentFormDialog>
  </div>
</template>
<style lang="scss" module>

.orderformSection {
  :global {
    .orderformSection {
      &__right {
        position: relative;
        width: 43%;
        height: calc(100vh);
        overflow: hidden;
        .orderformSection__right__header {
          background-color: $color-line;
          z-index: 999;
        }

        &__title {
          margin: 0;
          padding: 19px 0;
          padding-left: 50px;
        }
        &__header {
          position: relative;
          border-bottom: $color-border-base 1px solid;
          .el-drawer__close-btn {
            // font-weight: 300;
            color: #72767b;
            position: absolute;
            padding: 15px;
            border: 0;
            left: 0;
            top: 3px;
          }
          .el-tabs__item {
            height: auto;
            padding: 10px 0;
          }
          .el-tabs__nav-wrap::after {
            display: none;
          }
          .el-tabs__header {
            margin-bottom: 0;
          }
          .el-tabs--top {
            margin-left: 60px;
            @include max-lg {
              margin-left: 30px;
            }
          }
        }
        &__content {
          z-index: 10;
          height: calc(100vh - 60px);
          overflow: auto;
          padding: 30px;
          padding-bottom: 120px;
          position: relative;
          background-color: $color-line;
          @include max-lg {
            padding: 20px;
          }
        }
      }
    }
    .payment-radio {
      width: 100%;
      h6 {
        margin-top: 0;
      }
      :global {
        .el-radio-group {
          display: flex;
          flex-wrap: wrap;
          margin-right: -15px;
        }
        .el-radio {
          margin-right: 15px;
          border-radius: 7px;
          margin-left: 0 !important;
          width: calc(50% - 15px);
          background-color: #fff;
          margin-bottom: 15px;
        }
      }
    }
  }
}
</style>
